import { styled } from '@mui/material';

export const ReplaySliderWrapper = styled('div')(({ theme }) => ({
    height: 80,
}));
